export default class ErrorReporter {

    static report(error, id = null, type = null) {
        EventBus.fire(type || 'top-alert', {
            id: id || 'top-alert',
            message: ErrorReporter.message(error),
        });
    }

    static message(error) {
        if (typeof error === 'string') {
            return error;
        }
        return ((error.response || {}).data || {}).message || 'Request failed'
    }
}
